import _ from 'underscore';

import { filterQuery, getQueryString } from './url';

export const addCleanCache = (params, cleanCache) => {
	if (cleanCache) {
		return { ...params, cleanCache };
	}

	return params;
};

const availablePathParams = [
	'actor',
	'director',
	'genre',
	'year',
	'withTifloComments',
	'schoolClass',
	'lecturer',
	'institute',
	'type',
	'location',
	'country',
	'tag',
	'author',
	'rubric',
	'instituteType',
	'minPrice',
	'maxPrice',
	'tags',
	'seanceStartDate',
	'seanceEndDate',
	'season'
];

export const parsePathParams = (pathParams, options = {}) => {
	const params = pathParams || [];
	const nonKeyField = options.nonKeyField || 'rubric';

	return params.reduce(
		(acc, pathParameter) => {
			const parameter = pathParameter.split('-');
			const [key, ...value] = parameter;

			if (_(availablePathParams).contains(key)) {
				acc.params[key] = value.join('-');
			} else if (pathParameter === 'pushkinskaya-karta') {
				acc.isPushkinsCard = true;
			} else {
				acc[nonKeyField].push(pathParameter);
			}

			return acc;
		},
		{ params: {}, [nonKeyField]: [], isPushkinsCard: false }
	);
};

const arrayApiParams = {
	genre: {
		specialAfisha: 'genreNames',
		default: 'genres'
	},
	actor: 'actors',
	director: 'directors',
	year: 'years',
	institute: 'institutes',
	lecturer: 'lecturers',
	theater: 'institutes',
	type: 'types'
};

export const preparePathParams = (params, pathParams, type) => {
	let newParams = { ...params };

	// eslint-disable-next-line no-param-reassign
	type = type || 'default';

	_(pathParams).each((value, key) => {
		if (arrayApiParams[key]) {
			let apiParamsKey = arrayApiParams[key];

			if (_(apiParamsKey).isObject() && apiParamsKey[type]) {
				apiParamsKey = apiParamsKey[type];
			}

			newParams = { ...newParams, [apiParamsKey]: [value] };
		} else {
			newParams = { ...newParams, [key]: value };
		}
	});

	return newParams;
};

export const composePath = (prefix, params, exceptAvailableParams = []) => {
	const filteredParams = filterQuery(params);

	const resultAvailableParams = _(availablePathParams).difference(
		exceptAvailableParams
	);

	const pathParams = _(filteredParams).pick(resultAvailableParams);
	const queryParams = _(filteredParams).omit(resultAvailableParams);

	const pathString = Object.entries(pathParams)
		.map((iterator) => iterator.join('-'))
		.join('/');

	const pathResult = pathString ? `/${pathString}` : '';

	const queryString = getQueryString(queryParams);

	return _.compact([`${prefix}${pathResult}`, queryString]).join('?');
};

export const composeObjectPath = (
	params,
	pathParamsFieldName = 'pathParams'
) => {
	const filteredParams = filterQuery(params);

	const queryParams = _(filteredParams).omit(availablePathParams);
	const pathParams = _(filteredParams).pick(availablePathParams);
	const pathParts = Object.entries(pathParams).map((iterator) =>
		iterator.join('-')
	);

	return { [pathParamsFieldName]: pathParts, ...queryParams };
};

export const prepareDateParams = (params) => {
	let newParams = {};

	_(params).each((value, key) => {
		if (value instanceof Date) {
			newParams = { ...newParams, [key]: value.toISOString() };
		} else {
			newParams = { ...newParams, [key]: value };
		}
	});

	return newParams;
};

export const getBreadcrumbsParams = (rubricPath, params) =>
	addCleanCache({ rubricPath, cached: true }, params.cleanCache);

export const getMetaParams = (rubricPath, params, additionalParams) => {
	const newAdditionalParams = _({}).extend(additionalParams);

	return addCleanCache(
		{
			rubricPath,
			...newAdditionalParams,
			cached: true
		},
		params.cleanCache
	);
};
